export const translationPath = 'AsyncDownload';